/**
 * Encrypted Media Extensions (EME) / MSE surface checks for fingerprinting.
 * Only detects API presence and MSE codec support — does not call requestMediaKeySystemAccess
 * (avoids OS prompts such as Android "Allow protected content" / Widevine consent).
 */

/**
 * @returns {Promise<{
 *   emeSupported: boolean,
 *   mseSupported: boolean,
 *   mseVp9Webm: boolean | null,
 *   supportedCount: number,
 *   systems: Array<Record<string, unknown>>
 * }>}
 */
export async function getEncryptedMediaCapabilities() {
  const emeSupported =
    typeof navigator !== 'undefined' &&
    typeof navigator.requestMediaKeySystemAccess === 'function';
  const mseSupported = typeof window !== 'undefined' && 'MediaSource' in window;
  let mseVp9Webm = null;
  try {
    if (mseSupported && typeof MediaSource !== 'undefined' && MediaSource.isTypeSupported) {
      mseVp9Webm = MediaSource.isTypeSupported('video/webm; codecs="vp09.00.10.08"');
    }
  } catch {
    mseVp9Webm = null;
  }

  const status = emeSupported ? 'not-probed' : 'no-eme';
  const stub = (keySystem) => ({
    keySystem,
    supported: false,
    status,
    configuration: null,
  });

  return {
    emeSupported,
    mseSupported: !!mseSupported,
    mseVp9Webm,
    supportedCount: 0,
    systems: [
      stub('com.widevine.alpha'),
      stub('com.microsoft.playready'),
      stub('com.apple.fps'),
    ],
  };
}
